/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import get from 'lodash/get';
import LinkFarm from '../CMLinkFarm/LinkFarm';
import analyticsAction from '../../actions/AnalyticsAction';

const LinkFarmHandler = (props) => {
    const data = get(props, 'data', props);
    const { automationId } = data;
    const { teaserTitle, ctaLinks, urlHolder, altText } = data;

    const handleEvent = (logEvent) => {
        props.actions.triggerNavigationClick(logEvent);
    };

    return (
        <LinkFarm
            triggerNavigationClick={handleEvent}
            automationId={automationId}
            altText={altText}
            teaserTitle={teaserTitle}
            ctaLinks={ctaLinks}
            urlHolder={urlHolder}
            {...props}
        />
    );
};

LinkFarmHandler.defaultProps = {
    actions: {},
    automationId: '',
    altText: '',
    teaserTitle: '',
};

LinkFarmHandler.propTypes = {
    actions: PropTypes.object,
    automationId: PropTypes.string,
    altText: PropTypes.string,
    teaserTitle: PropTypes.string,
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators({ ...analyticsAction }, dispatch),
});

export default connect(null, mapDispatchToProps)(LinkFarmHandler);
